import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col
} from "reactstrap";

const EditContactUs = () => {
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Edit Contact</h3>
              </CardHeader>
              <CardBody>
                <div>

        
                <Form >
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Name</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      id="name"
                      name="name"
                      placeholder="Enter  Name"
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  {/* <FormGroup>
                    <Label for="exampleEmail">Profile Picture</Label>
                    <Input
                      id="image"
                      name="image"
                      type="file"
                      placeholder="Enter Answer"
                    />
                  </FormGroup> */}

                  <FormGroup>
                    <Label for="exampleEmail">Profile Image</Label>
                    <Input
                      style={{
                        border: "1px solid lightgrey",
                        padding: "6px 10px",
                        borderRadius: "6px",
                      }}
                      id="name"
                      name="image"
                      type="file"
                    />
                  </FormGroup>


                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Phone No.</Label>
                    <Input id="phoneno" name="phoneno" type="number" placeholder="Enter Phone No." />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Whatapp No.</Label>
                    <Input id="Priority" name="Whatappno." type="number" placeholder="Enter Whatapp No." />
                  </FormGroup>
                </Col>

              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Email</Label>
                    <Input id="phoneno" name="email" type="email" placeholder="Enter  email" />
                  </FormGroup>
                </Col>


                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Designation</Label>
                    <Input id="Priority" name="Whatappno." type="number" placeholder="Enter Designation" />
                  </FormGroup>
                </Col>


              </Row>

              <Row>
              <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Role</Label>
                    <Input id="status" name="status" type="select" required>
                      <option value="">select option</option>
                      <option value="Activate">Suggestion</option>
                      <option value="Deactivate">Feedback</option>
                      <option value="Pending">Complaints</option>
                    </Input>
                  </FormGroup>
                </Col>

                
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Priority</Label>
                    <Input id="Priority" name="Whatappno." type="number" />
                  </FormGroup>
                </Col>

                
              
                </Row>

                <Row>
                <Col md={12}>
                        <FormGroup>
                          <Label for="exampleEmail">Type</Label>
                          <Input id="forType" name="forType" type="select">
                            <option value="driver">select option</option>
                            <option value="user">Tutor</option>
                            <option value="both">Student</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      </Row>

              {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button color="secondary" >
                  Cancel
                </Button>
         
  
                  <Button
                    color="primary"
                    type="submit"
                    style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white",border:"none"}}
                  >
                    Save
                  </Button>
           
              </div>
            </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};






export default EditContactUs